import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as ArrowIcon } from '@assets/icons/arrrow.svg';

import { standardFormsEnum } from '@asd-stan/standard/domain/enums';
import { ReactComponent as Plus } from '@assets/asd-stan-works/icons/plus-icon.svg';
import { Button } from '@components/button/button';
import Popover from '@components/popover/popover';
import { StyledAddNew } from '@asd-stan/standard/components/standard-list/standard-list.styled';

export default function AddStandardBtn() {
	return (
			<Popover
				trigger={<Toggle />}
				content={<Content />}
			/>
	);
}

const Toggle = memo(() => {
	const { t } = useTranslation();
	return <Button
		icon={<Plus fill="#fff" />}
		title={t('standard.standardList.buttons.addNew')}
		rightIcon={<ArrowIcon />}
	/>
})

const Content = memo(() => {
	return(
		<StyledAddNew>
			<Link to={`/standards/new-standard`} >ASD-STAN prEN / TR</Link>
			<Link to={`/standards/new-standard-ea`} >ASD-STAN EA</Link>
		</StyledAddNew>
	)
})